module.exports = __webpack_public_path__ + "static/media/halfpipe-wipeout.6a5e4d62.mov";